if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }

    open() {
      this.notification.classList.add('animate', 'active');

      this.notification.addEventListener(
        'transitionend',
        () => {
          this.notification.focus();
          trapFocus(this.notification);
        },
        { once: true }
      );

      document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);

      removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (!element) return;

        // カスタムヘッダーのカートアイコンの場合はバッジのみ更新
        if (section.id === 'cart-icon-bubble') {
          const customBadge = element.querySelector('.custom-header__cart-badge');
          if (customBadge) {
            // sectionsのHTMLからカート数を取得
            const sectionHtml = parsedState.sections[section.id];
            if (sectionHtml) {
              const tempDiv = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const cartCountBubble = tempDiv.querySelector('.cart-count-bubble span[aria-hidden="true"]');
              const itemCount = cartCountBubble ? parseInt(cartCountBubble.textContent.trim()) : 0;
              customBadge.textContent = itemCount >= 100 ? '99+' : itemCount;
              customBadge.style.display = itemCount > 0 ? '' : 'none';
            }
            return; // カスタムヘッダーの場合はHTMLを置き換えない
          }
        }

        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (this.header) this.header.reveal();
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.notification && !target.closest('cart-notification')) {
        const disclosure = target.closest('details-disclosure, header-menu');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
}
